"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Nationwide Real Estate Experts",
  description: "Access a vetted network of licensed professionals in all 50 states, ensuring a seamless transition to your new home.",
  dotColor: "bg-primary"
}, {
  title: "Relocation & Logistics",
  description: "From competitive mortgage lenders to specialized moving companies, we coordinate every detail of your exit.",
  dotColor: "bg-chart-1"
}, {
  title: "Destination Research",
  description: "In-depth analysis of taxes, cost of living, and lifestyle factors to help you choose the perfect new state.",
  dotColor: "bg-chart-4"
}];
export default function HumanStandardPerformance() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234420" id="our-nationwide-partner-network" className="bg-background py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {}
          <div ref={textRef} className={`transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="text-primary text-sm font-semibold tracking-wider uppercase mb-4 block font-default">
              Our Network
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-foreground mb-6 leading-tight font-default">
              Our Nationwide Network of Trusted Partners
            </h2>
            <p className="text-lg text-muted-foreground mb-12 max-w-xl font-default">
              LeavingIL.com has trusted partners all across the US. Let's have a conversation so we can get the right partners for your specific needs.
            </p>

            <div className="flex flex-col gap-8">
              {features.map((feature, i) => <div data-index={i} key={i} className="flex gap-5 items-start">
                  <div className={`w-3 h-3 rounded-full mt-2 shrink-0 ${feature.dotColor}`} aria-hidden="true" />
                  <div>
                    <h3 className="text-xl font-semibold text-foreground mb-2 font-default">
                      {feature.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed font-default">
                      {feature.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div ref={imageRef} className={`transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative w-full aspect-[4/5] lg:aspect-square rounded-md overflow-hidden shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/us_at_night_satellite.png" alt="Satellite view of the United States at night showing city lights" className="object-cover w-full h-full" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-foreground/5 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}